import { all, takeLatest, select, call, put } from 'redux-saga/effects';

import {
  types,
  fetchPromotionBannerSuccess,
  openPromotionBanner,
} from '@dragonfruit/redux/promotionBanner';
import { getRegion } from '@dragonfruit/redux/locale';
import { actions as errorActions } from '@dragonfruit/redux/error';

import { apiFetchWebMarquee } from '@dragonfruit/services/apis';

export function* fetchPromotionBannerFlow(action) {
  const { page } = action.payload;
  try {
    const region = yield select(getRegion);

    let webMarqueeResult = yield call(apiFetchWebMarquee, page, region);
    if (!!webMarqueeResult && Array.isArray(webMarqueeResult)) {
      webMarqueeResult = undefined;
    }
    if (!!webMarqueeResult) {
      yield put(openPromotionBanner());
    }

    yield put(fetchPromotionBannerSuccess(`${page}Banner`, webMarqueeResult));
  } catch (err) {
    yield put(errorActions.sendError(err));
  }
}

export default function*() {
  yield all([
    takeLatest(types.FETCH_PROMOTION_BANNER, fetchPromotionBannerFlow),
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/promotionBanner.js